const GlobalTemplatesChannel = {
  channel: import.meta.env.VITE_GLOBAL_TEMPLATES_CHANNEL
    ? Number(import.meta.env.VITE_GLOBAL_TEMPLATES_CHANNEL)
    : undefined,
};

export default GlobalTemplatesChannel;
